<template>
  <div
    :class="`award-bar--${supportedTheme}`"
    class="award-bar ds-padding-y-48 ds-md-padding-y-96 ds-padding-x-24"
  >
    <div class="ds-grid ds-justify-content-center">
      <DsImageElement
        :image="primaryImage"
        class="ds-grid__col ds-grid__col--12 ds-md-grid__col--4"
      />
      <template v-if="secondaryImage">
        <div
          v-if="isScreenSmall"
          class="award-bar__divider ds-grid__col ds-grid__col--2"
          :class="`award-bar__divider--${supportedTheme}`"
        />
        <div
          v-else
          class="ds-width-full ds-padding-y-48 ds-padding-x-24 t"
        >
          <DsDivider />
        </div>
        <DsImageElement
          :image="secondaryImage"
          class="ds-grid__col ds-grid__col--12 ds-md-grid__col--4"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { DsDivider, DsImageElement } from 'awds'
import { themeProp } from '#layers/core/composables/useTheme'

const { isScreenSmall } = useScreen()

const componentName = 'TerminalsAwardsBar'

defineOptions({
  name: componentName
})

const props = defineProps({
  ...themeProp,
  primaryImage: {
    type: Object,
    required: true
  },
  secondaryImage: {
    type: Object,
    default: null
  }
})

const supportedTheme = computed(() => {
  const NOT_SUPPORTED_THEMES = new Set([themeOptions.green])
  if (NOT_SUPPORTED_THEMES.has(props.theme)) {
    return themeOptions.light
  }
  return props.theme
})
</script>

<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';
@import 'awds/foundation-mixins.scss';

.award-bar {
  &__divider {
    border-left: $border-width-1 $border-style $color-grey-500;
    height: auto;
    transform: translateX(50%);
    width: 1px;

    &--light,
    &--grey {
      border-color: $color-grey-500;
    }

    &--dark {
      border-color: $color-grey-2500;
    }
  }

  &--light {
    background-color: $color-white;
  }

  &--grey {
    background-color: $color-grey-100;
  }

  &--dark {
    background-color: $color-grey-3200;
  }
}
</style>
